import { render, staticRenderFns } from "./ConstanciaConvenios.vue?vue&type=template&id=40bbfa64&"
import script from "./ConstanciaConvenios.vue?vue&type=script&lang=js&"
export * from "./ConstanciaConvenios.vue?vue&type=script&lang=js&"
import style0 from "./ConstanciaConvenios.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VImg,VRow})
